<template>
    <div>
        <v-dialog v-model="passwordDialog" persistent max-width="600px">
            <v-card>
                <v-toolbar card color="white" class="black--text">
                <v-spacer></v-spacer>
                <v-toolbar-title v-if="first_login === 'true'">First Login & Password Change</v-toolbar-title>
                <v-toolbar-title v-else> Password Change</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat icon color="grey" @click="closePasswordDialog()">
                    <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pb-0">
                <v-form>
                    <v-container>
                    <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                        
                        <v-text-field
                            v-model="oldpassword"
                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                            :rules="[rules.required, rules.min]"
                            :type="show1 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Old Password"
                            hint="At least 8 characters"
                            counter
                            @click:append="show1 = !show1"
                        ></v-text-field>
                        </v-flex>
                        </v-layout>
                
                        <v-layout>
                        <v-flex lg12 md12 sm12 xs12>
                        <v-text-field
                            v-model="newpassword"
                            :append-icon="show2 ? 'visibility' : 'visibility_off'"
                            :rules="[rules.required, rules.min]"
                            :type="show2 ? 'text' : 'password'"
                            name="input-10-1"
                            label="New Password"
                            hint="At least 8 characters"
                            counter
                            @click:append="show2 = !show2"
                        ></v-text-field>
                        </v-flex>
                        </v-layout>
                        
                        <v-layout>
                        <v-flex lg12 md12 sm12 xs12>
                        <v-text-field
                            v-model="confirmpassword"
                            :append-icon="show3 ? 'visibility' : 'visibility_off'"
                            :rules="[rules.required, rules.min]"
                            :type="show3 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Confirm Password"
                            hint="At least 8 characters"
                            counter
                            @click:append="show3 = !show3"
                        ></v-text-field>
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-form>
                </v-card-text>
                <v-card-actions>
                <v-btn color="blue darken-1" flat @click="closePasswordDialog()">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="changePwd()">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import {URL} from '../../../env'

export default {
    props: {
        passwordDialog: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            user_id: localStorage.getItem("user_id"),
            first_login: localStorage.getItem("first_login"),
            show1: false,
            show2: false,
            show3: false,
            newpassword: '',
            confirmpassword: '',
            oldpassword: '',
            rules: {
                min: v => v.length >= 8 || 'Min 8 characters',
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(value) || 'Invalid e-mail.'
                }
            },
        }
    },
    methods:{
        closePasswordDialog(){
            this.confirmpassword = null
            this.newpassword = null
            this.$emit('closePasswordDialog')
        },
        async changePwd() {
            let app = this
            if(this.oldpassword == this.newpassword){
                alert("Your new password is same as old password");
                return false;
            }
            if(this.newpassword !== this.confirmpassword){
                alert("Your new password and confirm password are not matching");
                return false;
            }
            let data = {
                user_id: this.user_id,
                password: this.newpassword,
                oldpassword: this.oldpassword,
                first_login: (this.first_login == 'true') ? 'false' : 'false'
            }
            await axios.post(`${URL}/api/updateSyndicateUserPwd`, data).then(res=>{
                localStorage.setItem("first_login", 'false')
                app.flash('Password Changed Successfully', 'success',{
                    timeout: 3000
                });
                app.closePasswordDialog()
            }).catch(err=>{
                if(err.response && err.response.status === 401){
                    alert('Your old password is wrong');
                } else {
                    app.flash('Something went wrong', 'error');
                }
            })
            
        }
    }
}
</script>